import { AccountMenuService } from '@account/services';
import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticService, AuthService, NotifyService } from '@app/services';
import { RemindersIndexView as EmployeeRemindersIndexView } from '@employees/views';

@Component({
    templateUrl: './reminders-index.template.html',
    styleUrls: ['./reminders-index.style.scss'],
})
export class RemindersIndexView extends EmployeeRemindersIndexView {
    isSelfEmployeeView = true;

    constructor(
        protected element: ElementRef,
        protected route: ActivatedRoute,
        protected auth: AuthService,
        protected notify: NotifyService,
        public tabMenuService: AccountMenuService,
        protected analyticsService: AnalyticService
    ) {
        super(element, route, auth, notify, analyticsService);
    }
}
